<template>
    <div class="container">
<!--        <div class="newsbg">-->
<!--            <img src="../../assets/images/newsbg4.png" width="100%" height="100%"/>-->
<!--            <div class="bgtitle">-->
<!--                <h1>新闻中心</h1>-->
<!--                <span>NEWS&nbsp;&nbsp;&nbsp;&nbsp;CENTER</span>-->
<!--            </div>-->
<!--        </div>-->
      <div class="banner">
        <template>
          <el-carousel arrow="always" class="bannerbox" :height="imgHeight + 'px'" style="width:100%">
            <el-carousel-item v-for="item in bannerList" :key="item.id">
              <div class="bannermain"><img ref="image" :src="item.url" width="100%" height="auto"/></div>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>
        <!-- <div class="navcontainer">
            <div class="navmain">
                <span>首页</span>
                <span>/</span>
                <span @click="goback">新闻中心</span>
                <span>/</span>
                <span style="color:rgb(73,129,243)">新闻详情</span>
            </div>
        </div> -->
        <div class="detMain">
            <div class="detbody">
                <div class="bodytitle">
                    <span>{{newsdetInfo.title}}</span>
                </div>
                <div class="baseInfo">
                    <div class="date">
                        <span><i class="el-icon-timer"></i></span>
                        <span>{{newsdetInfo.date}}</span>
                    </div>

                </div>
                <div class="itemBody">
                  <div class="item ql-snow ql-editor" v-html="newsdetInfo.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return{
            newsdetInfo:{},
          imgHeight:"",
          bannerList:[]
        }
    },
    methods:{
      initBanner(){
        let that=this;
        axios.get('http://www.thingo.com.cn/thingo-server/website/news/center/banner').then((res) => {
          that.bannerList = res.data.data;
          window.addEventListener("resize",this.resize,true)
        })
      },
        getInfo(){
            let id = this.$route.query.newsId
            axios.get('http://www.thingo.com.cn/thingo-server/website/news/center/details/'+id).then(res => {

                this.newsdetInfo = res.data.data
                this.newsdetInfo.date = this.newsdetInfo.createTime.slice(0,10)
            })
        },
        goback(){
            this.$router.push('/news/index')
        },
      imgLoad(){
        // setTimeout(()=>{
        //   this.imgHeight = this.$refs.image[0].height
        // },500)
        let scrollWidth = document.body.scrollWidth
        if (scrollWidth < 1366) {
          setTimeout(()=>{
            this.imgHeight = this.$refs.image[0].height
          },500)
        } else {
          setTimeout(()=>{
            this.imgHeight = this.$refs.image[0].height
          },200)
        }
      },
      resize(){
        this.imgHeight = this.$refs.image[0].height
      }
    },
    mounted(){
      this.imgLoad()
      this.initBanner()
        this.getInfo()
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.pageXOffset = 0
    },
  beforeDestroy() {
    window.removeEventListener('resize',this.resize,true)
  }
}
</script>

<style scoped>
.banner{
  width: 100%;
  height: auto;
}
    .newsbg{
        width: 100%;
        height: auto;
    }
    .newsbg .bgtitle{
        width: 240px;
        height: auto;
        position: absolute;
        left: 20%;
        top: 20%;
    }
    .newsbg .bgtitle h1{
        font-size: 50px;
        font-family: 'PingFangSC-Medium';
        color: #ffffff;
        margin: 0 0 30px 0;
        padding: 0;
        font-weight: 400;
    }
    .newsbg .bgtitle span{
        font-size: 28px;
        font-family: 'Arial-BoldMT';
        color: #ffffff;
    }
    .navcontainer{
        width: 100%;
        height: 50px;
        background-color: rgb(246,248,251);
    }
    .navcontainer .navmain{
        width: 300px;
        height: 50px;
        display: flex;
        align-items: center;
        position: relative;
        left: 200px;
    }
    .navcontainer .navmain span{
        font-family: 'PingFang SC', 'PingFang SC-Regular';
        margin-right: 5px;
        font-size: 16px;
        cursor: pointer;
    }
    .detMain{
        width: 100%;
        height: auto;
    }
    .detMain .detbody{
        width: 100%;
        height: auto;
        margin: 50px auto 100px auto;
    }
.detMain .detbody .itemBody{
  margin: 0 auto;
  width: 50%;
}
    .detMain .detbody .bodytitle{
        width: 100%;
        height: auto;
        text-align: center;
    }
    .detMain .detbody .bodytitle span{
        font-size: 30px;
        font-family: 'PingFangSC-Medium';
        color: #000000;
    }
    .detMain .detbody .baseInfo {
        margin-top: 20px;
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: center;
        border-bottom: 1px solid #e0e5ee;
    }
    .detMain .detbody .baseInfo .date{
        position: relative;
    }
    .detMain .detbody .baseInfo .view{
        position: relative;
        left: 10%;
    }
    .detMain .detbody .baseInfo i{
        color: rgb(42,132,203);
    }
    .detMain .detbody .baseInfo span{
        font-size: 16px;
        font-family: 'PingFangSC-Regular';
        color: #3e4956;
    }
    .detMain .detbody .item{
        width: 100%;
        height: auto;
    }


    .detMain .detbody .item{
        width: 100%;
        height: auto;
        margin-bottom: 50px;
    }
    .detMain .detbody .item  p{
        font-size: 16px;
        font-family: 'PingFangSC-Regular';
        color: #000000;
        text-indent: 2em !important;
    }

    .detMain .detbody .item .itemimg{
        width: 100%;
        height: auto;
    }

@media screen and (max-width: 1200px) {
  .detMain .detbody .itemBody{
    width: 60%;
  }
}
@media screen and (max-width: 900px) {
  .detMain .detbody .itemBody{
    width: 80%;
  }
}
@media screen and (max-width: 600px) {
  .detMain .detbody .itemBody{
    width: 90%;
  }

}


    @media screen and (max-width: 664px) {
        .newsbg .bgtitle{
            top: 12%;
            left: 12%;
        }
        .newsbg .bgtitle h1{
            font-size: 30px;
            margin: 0 0 10px 0;

        }
        .newsbg .bgtitle span{
            font-size: 10px;

        }
        .detMain .detbody .bodytitle span{
            font-size: 16px;
        }
    }
</style>
<style >
.detMain .detbody .item img{
        width: 100%;
        height: 100%;
    }
.detMain .detbody .item p{
    letter-spacing: 1.5px;
    font-size: 16px;
    font-family: 'PingFangSC-Regular';
    color: #000000;
    margin-top: 20px;
    line-height: 25px;
}
</style>
